import React, {useCallback} from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {toast} from "react-hot-toast";
import {faCopy} from "@fortawesome/pro-solid-svg-icons/faCopy";

export interface CopyButtonProps {
  text: string;
  alertMessage?: string;
  element?: React.ReactNode;
  className?: string;
  iconClass?: string;
  noIcon?: boolean;
}

export default function CopyButton(
  {
    text,
    element,
    alertMessage = 'Copied to clipboard',
    className = 'btn btn-link p-0 tx-left',
    iconClass = 'tx-muted tx-12 ms-2',
    noIcon = false,
  }: CopyButtonProps
) {

  const handleCopy = useCallback(() => {
    toast.success(alertMessage + '', {duration: 5000});
  }, [alertMessage]);

  return (
    <CopyToClipboard text={text} onCopy={handleCopy}>
      <button className={className}>
        {element !== undefined ? element : text}{!noIcon && (
          <span className={iconClass}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M6.91402 2.62636C6.90353 2.63682 6.86889 2.67134 6.84581 2.84302C6.82031 3.03263 6.81918 3.29333 6.81918 3.71247V4.56961C6.81918 4.86416 6.5804 5.10294 6.28585 5.10294C5.9913 5.10294 5.75252 4.86416 5.75252 4.56961V3.71247C5.75252 3.70128 5.75251 3.69014 5.75251 3.67903C5.75248 3.30368 5.75245 2.97012 5.78865 2.70088C5.82799 2.40833 5.91865 2.11324 6.15978 1.87211C6.40092 1.63098 6.69601 1.54032 6.98856 1.50098C7.2578 1.46479 7.59136 1.46481 7.9667 1.46485H12.3193C12.6946 1.46481 13.0282 1.46479 13.2974 1.50098C13.59 1.54032 13.8851 1.63097 14.1262 1.8721C14.3673 2.11324 14.458 2.40833 14.4973 2.70088C14.5335 2.97012 14.5335 3.30368 14.5335 3.67903V8.03162C14.5335 8.40696 14.5335 8.74052 14.4973 9.00976C14.458 9.30232 14.3673 9.5974 14.1262 9.83853C13.8851 10.0797 13.59 10.1703 13.2974 10.2097C13.0282 10.2459 12.6946 10.2458 12.3193 10.2458L11.4287 10.2458C11.1342 10.2458 10.8954 10.007 10.8954 9.71247C10.8954 9.41792 11.1342 9.17913 11.4287 9.17913H12.2858C12.705 9.17913 12.9657 9.178 13.1553 9.15251C13.327 9.12943 13.361 9.09524 13.3715 9.08475L13.3724 9.08383C13.3829 9.07337 13.4171 9.03931 13.4402 8.86763C13.4657 8.67801 13.4668 8.41732 13.4668 7.99818V3.71247C13.4668 3.29333 13.4657 3.03263 13.4402 2.84302C13.4171 2.67134 13.3829 2.63727 13.3724 2.62681L13.3715 2.6259C13.361 2.61541 13.327 2.58122 13.1553 2.55814C12.9657 2.53265 12.705 2.53151 12.2858 2.53151H8.00014C7.581 2.53151 7.3203 2.53265 7.13069 2.55814C6.95901 2.58122 6.92448 2.61586 6.91402 2.62636ZM3.68098 5.75056C3.69209 5.75056 3.70324 5.75056 3.71442 5.75056L8.03358 5.75056C8.40892 5.75053 8.74247 5.7505 9.01171 5.7867C9.30427 5.82603 9.59935 5.91669 9.84049 6.15783C10.0816 6.39897 10.1723 6.69405 10.2116 6.9866C10.2478 7.25584 10.2478 7.5894 10.2478 7.96474V12.3173C10.2478 12.6927 10.2478 13.0262 10.2116 13.2955C10.1723 13.588 10.0816 13.8831 9.84049 14.1242C9.59935 14.3654 9.30427 14.456 9.01171 14.4954C8.74247 14.5316 8.40892 14.5315 8.03358 14.5315H3.68098C3.30563 14.5315 2.97208 14.5316 2.70283 14.4954C2.41028 14.456 2.1152 14.3654 1.87406 14.1242C1.63293 13.8831 1.54227 13.588 1.50294 13.2955C1.46674 13.0262 1.46677 12.6927 1.4668 12.3173V7.96475C1.46677 7.5894 1.46674 7.25585 1.50294 6.98661C1.54227 6.69405 1.63292 6.39897 1.87405 6.15784C2.11519 5.9167 2.41028 5.82603 2.70283 5.7867C2.97208 5.7505 3.30563 5.75053 3.68098 5.75056Z" fill="currentColor"/>
            </svg>
          </span>
        )}
      </button>
    </CopyToClipboard>
  );
}
